import React from 'react';
import { useFormState } from 'react-final-form';

import BlockPageNavigation from './BlockPageNavigation';

type Props = {
  message: string;
};

export default function BlockFormNavigation({ message }: Props): JsxNode {
  const { dirty, submitSucceeded } = useFormState();

  if (submitSucceeded) {
    return null;
  }
  if (!dirty) {
    return null;
  }
  return <BlockPageNavigation message={message} />;
}
